<a
  class="relative flex h-full w-full cursor-pointer flex-col rounded-lg border border-gray-200/50 shadow-sm transition-all hover:-translate-y-2 hover:duration-500"
  [routerLink]="['/product', product.slug]">
  <div class="relative">
    <div class="relative">
      <img
        class="aspect-square w-full rounded-t-lg"
        [src]="productImgPath"
        (error)="handleProductImgError()"
        [alt]="product.name" />
      <div class="absolute top-1 right-1" *ngIf="product.has_vmakeup">
        <img
          class="z-10 aspect-square w-12 cursor-pointer transition duration-300 ease-in-out hover:scale-105"
          src="assets/images/tryon.webp"
          alt="try on"
          [routerLink]="" />
      </div>
    </div>
    <a
      *ngIf="!product.has_variant && product.discount_percentage"
      class="absolute top-1 left-1 flex h-12 w-12 items-center justify-center rounded-full bg-secondary-main text-center shadow-md shadow-secondary-light transition-all">
      <p class="font-bold text-white">{{ product.discount_percentage }}%</p>
    </a>
    <a
      *ngIf="
        product.has_variant &&
        (product.min_price != product.actual_min_price ||
          product.max_price != product.actual_max_price)
      "
      class="absolute top-1 left-1 flex h-12 w-12 items-center justify-center rounded-full bg-secondary-main text-center shadow-md shadow-secondary-light transition-all">
      <p class="font-bold text-white">
        {{ 100 - (product.min_price / product.actual_min_price) * 100 }}%
      </p>
    </a>
  </div>
  <div class="flex h-full flex-col p-3 pb-0">
    <div class="flex-1">
      <div class="text-xs uppercase text-primary-md-dark">
        {{ product.brand_name }} |
        <fa-icon class="mr-1 text-xs text-yellow-400" [icon]="faStar"></fa-icon>
        <span class="text-sm">{{ product.average_rating }}</span>
      </div>
      <div class="text-sm font-bold text-primary-darkest line-clamp-2">
        {{ product.name }}
      </div>
    </div>
    <div class="my-2 flex justify-between">
      <div class="flex-1 self-end" *ngIf="!product.has_variant">
        <div
          class="text-right text-xs text-gray-600 line-through"
          *ngIf="product.discount_percentage">
          {{ product.actual_max_price | fcCurrency }}
        </div>
        <div class="flex items-center">
          <div class="flex-1 text-right font-bold text-secondary-main">
            {{ product.max_price | fcCurrency }}
          </div>
        </div>
      </div>
      <div class="flex-1 self-end" *ngIf="product.has_variant">
        <div
          class="text-right text-xs text-gray-600 line-through"
          *ngIf="
            product.max_price != product.actual_max_price ||
            product.min_price != product.actual_min_price
          ">
          {{ product.actual_max_price | fcCurrency }}
        </div>
        <div class="flex justify-between">
          <p class="text-xs text-gray-600">Start from</p>
          <div class="text-right font-bold text-secondary-main">
            {{ product.min_price | fcCurrency }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showStockProgressBar">
    <div class="px-2 text-right text-xs text-primary-md-dark">
      {{ product.remaining_stock ? product.remaining_stock : 0 }} Available
    </div>
    <div
      class="h-2 rounded-lg border-2 border-ternary-light bg-ternary-lightest">
      <span
        [style.width.%]="stockProgressWidth"
        class="block h-full rounded-lg bg-ternary-main"></span>
    </div>
  </div>
</a>
